import styled from '@emotion/styled/macro';
import { PopoverItem, Variables } from '@enter/core';
import { ChartCard } from './chart-card';

export const PracticeSummaryCard = styled(ChartCard)``;
export const Contents = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding: 0 24px;
`;
export const OptionItem = styled(PopoverItem)`
    color: ${Variables.Colors.n100};
    font-weight: 500;
`;
export const Message = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 300px;
    flex-grow: 1;
    text-align: center;

    font-size: 18px;
    font-weight: 500;
`;
